import React, { useState } from 'react';
import Select from 'react-select';
import { useCsvPerformanceStore } from './store';
import useDebounce from '../../../hooks/useDebounce';
import { useFetchEmailTemplatesRaw } from '../../../query/template';

const TemplateFilterOptions = ({ innerProps, data }) => {
  return (
    <div
      className="react-select__option"
      style={{ padding: '4px 6px' }}
      {...innerProps}
    >
      <p className="text-ellipsis" style={{ marginBottom: 0, fontSize: 10 }}>
        {data.id} - {data.name}
      </p>
    </div>
  );
};

const LabelRender = ({ innerProps, data }) => {
  return (
    <div {...innerProps} style={{ overflow: 'hidden', padding: 2 }}>
      <p className="text-ellipsis" style={{ marginBottom: 0, fontSize: 10 }}>
        {data.id} - {data.name}
      </p>
    </div>
  );
};

export default function TemplateFilter() {
  const { selectedTemplates, setSelectedTemplates } = useCsvPerformanceStore();
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');

  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search],
  );
  const { data = [], isFetching } = useFetchEmailTemplatesRaw({
    search: debouncedSearch,
  });
  const [templates = []] = data;
  return (
    <Select
      classNamePrefix="react-select-small"
      components={{
        Option: TemplateFilterOptions,
        MultiValueLabel: LabelRender,
      }}
      filterOption={() => true}
      isClearable={false}
      isLoading={isFetching}
      isMulti
      isSearchable
      menuPortalTarget={document.body}
      options={templates.map(e => ({
        ...e,
        label: e.name,
        value: e.id,
      }))}
      placeholder="Filter by templates..."
      styles={{ fontSize: 10 }}
      value={selectedTemplates.map(e => ({
        ...e,
        label: e.name,
        value: e.id,
      }))}
      onChange={setSelectedTemplates}
      onInputChange={value => setSearch(value)}
    />
  );
}
